const areas = [
  {
    number: "01",
    icon: "ri-global-line",
    title: "Cross-Border Opportunity Advisory",
    desc: "Structured guidance on navigating investment and business opportunities across borders, with a focus on African markets, diaspora connections, and emerging economies.",
  },
  {
    number: "02",
    icon: "ri-bar-chart-grouped-line",
    title: "Investor Readiness Support",
    desc: "Helping clients assess their financial position, clarify their goals, and build the knowledge and confidence needed to engage with investment opportunities responsibly.",
  },
  {
    number: "03",
    icon: "ri-route-line",
    title: "Strategic Planning & Relationship Development",
    desc: "Long-term strategic advisory conversations that help clients map their wealth-building journey, identify key relationships, and develop actionable next steps.",
  },
  {
    number: "04",
    icon: "ri-building-4-line",
    title: "Family Office Support",
    desc: "Guidance for families seeking to establish or strengthen family office structures, governance frameworks, and intergenerational wealth transfer strategies.",
  },
  {
    number: "05",
    icon: "ri-funds-line",
    title: "Private Credit & Co-Investment Guidance",
    desc: "For qualified partners, structured introductions and advisory support around private credit opportunities and co-investment pathways within our trusted network.",
  },
  {
    number: "06",
    icon: "ri-book-open-line",
    title: "Wealth-Building Education",
    desc: "Advisory tied to ongoing financial education &mdash; ensuring clients build the knowledge foundation needed to make informed, disciplined long-term decisions.",
  },
];

export default function CoreAdvisoryAreas() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-14 items-start">
          {/* Left sticky label */}
          <div className="lg:col-span-2 lg:sticky lg:top-28">
            <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
              <span className="w-8 h-px bg-[#C9A961]" />
              Core Advisory Areas
            </span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
              Where We Can Guide You
            </h2>
            <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
              Our advisory areas are designed to meet clients at every stage of their wealth-building journey &mdash; from foundational education to advanced cross-border strategy.
            </p>
            <img
              src="/assets/images/site/adv-areas-001-600x500.jpg"
              alt="Harambee advisory areas cross-border investment guidance"
              className="w-full h-[320px] object-cover object-top rounded-lg"
            />
          </div>

          {/* Right - Areas grid */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {areas.map((area) => (
              <div
                key={area.number}
                className="bg-[#F8F6F3] rounded-lg p-7 border border-[#E8E4DC] hover:border-[#C9A961]/40 transition-all duration-300 group"
              >
                <div className="flex items-center justify-between mb-5">
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 group-hover:bg-[#1A4D3C]/20 transition-colors">
                    <i className={`${area.icon} text-[#1A4D3C] text-lg`} />
                  </div>
                  <span className="font-['Cormorant_Garamond'] text-3xl font-bold text-[#E8E4DC] group-hover:text-[#C9A961]/30 transition-colors">
                    {area.number}
                  </span>
                </div>
                <h3 className="font-semibold text-[#2B2D2F] text-sm mb-2 leading-snug">
                  {area.title}
                </h3>
                <p className="text-[#6B6B6B] text-xs leading-relaxed">{area.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
